import { NumericInput } from 'views/ProductPage/configurators/numericInput';
import { ConstraintType } from 'models/ConstraintType';
import { Attribute, useConfigurator } from 'views/ProductPage/configurators/useConfigurator';
import { IConstraint } from 'models/IConstraint';
import { Validate, isValueConstraint } from 'views/ProductPage/configurators/rules';
import connect from 'components/Shared/connect';
import { getConfiguratorConstraint } from 'views/ProductPage/selector';
import { onBlurField } from 'views/ProductPage/configurators/actions';
import { rm } from 'utils';

type HeightAttribute = Attribute & {
  validate: Validate;
  rules: IConstraint[];
  calcDoorWidth: (width: number, doors: number) => number;
  doors: string;
  onBlur: () => void;
};

export const Height = connect<HeightAttribute, Attribute, { constraints: IConstraint[] }>(
  state => ({
    constraints: getConfiguratorConstraint(state.currentPage)
  }),
  dispatch => ({
    onBlur: () => {
      dispatch(onBlurField());
    }
  }),
  ({ constraints, ...state }, dispatch, props) => ({
    ...state,
    ...dispatch,
    ...props,
    rules: constraints.filter(
      c =>
        c.attribute === props.id &&
        (c.rule === ConstraintType.Min ||
          c.rule === ConstraintType.Max ||
          c.rule === ConstraintType.MinMax)
    )
  })
)(function _Height({ validate, ...a }: HeightAttribute) {
  const { onSelectChange } = useConfigurator();
  const onBlur = (input: string) => {
    const result = validate(a.id, input);
    onSelectChange(a.id, isValueConstraint(result) ? result.value.toString() : input);
    setTimeout(a.onBlur, 0);
  };

  return (
    <NumericInput
      {...a}
      onBlur={onBlur}
      toolTip={rm('Product_Configurator_SlidingDoor_Height_ToolTip')}
    />
  );
});
